export default __webpack_public_path__ + "locales/sr-Cyrl-RS/UploadPanel.json?hash=3c1f4864b6dfe5bcc314fa4f977dcd3e";